import { createPropertyEntityStrategy } from '../strategies/property';
import { useOnObjectsUpdated } from './useOnObjectsUpdated';
import { createAssociationEntityStrategy } from '../strategies/association';
import { useMemo } from 'react';
import { useHttpClient } from '../../client/HttpClientContext';
export function useAutosaveStrategyMap() {
  const onObjectsUpdated = useOnObjectsUpdated();
  const httpClient = useHttpClient();
  return useMemo(() => ({
    PROPERTY: createPropertyEntityStrategy(httpClient, onObjectsUpdated),
    ASSOCIATION: createAssociationEntityStrategy(httpClient)
  }), [onObjectsUpdated, httpClient]);
}